import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "section__padding" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Project Name")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Description")
const _hoisted_4 = { class: "section__padding" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Nodes Portal Project Information")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Project")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Market")
const _hoisted_8 = { class: "section__padding" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Grid Root Node")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Type")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Nettstasjon")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Transformator")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Transformer Circuit")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Find")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_search_component = _resolveComponent("search-component")!
  const _component_google_map_component = _resolveComponent("google-map-component")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
    style: {"height":"100%","display":"flex","flex-flow":"column"}
  }, [
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { style: {"height":"100%","display":"flex","flex-flow":"column"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_ion_row, { class: "line_item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            id: "name",
                            modelValue: _ctx.form.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "floating" }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_textarea, {
                            id: "description",
                            modelValue: _ctx.form.description,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            id: "project",
                            required: "",
                            placeholder: "Select...",
                            modelValue: _ctx.form.nodesGridNodeId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.nodesGridNodeId) = $event)),
                            interface: "popover"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridNodes, (item) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: item.id,
                                  value: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(`${item.name} ${
                        item.comments ? ` - ${item.comments}` : ""
                      }`), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            id: "market",
                            required: "",
                            placeholder: "Select...",
                            modelValue: _ctx.form.nodesMarketId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.nodesMarketId) = $event)),
                            interface: "popover"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markets, (item) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: item.id,
                                  value: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(`${item.name} ${
                        item.comments ? ` - ${item.comments}` : ""
                      }`), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            id: "type",
                            required: "",
                            placeholder: "Select...",
                            modelValue: _ctx.form.grid.componentName,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.grid.componentName) = $event)),
                            interface: "popover"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "NETTSTASJON" }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "FORDELINGSTRANSFORMATOR" }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            required: "",
                            id: "circuit",
                            modelValue: _ctx.form.grid.transformerCircuit,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.grid.transformerCircuit) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ion_button, {
                            size: "small",
                            onClick: _cache[6] || (_cache[6] = () => (_ctx.findRootNode = !_ctx.findRootNode))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.findRootNode)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 0,
                    style: {"flex-grow":"1"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_search_component, {
                            typeAhead: true,
                            components: "TRANSFORMER,SUBSTATION",
                            selected: _ctx.markerSelected,
                            onSelected: _ctx.handleSelectedRootNode,
                            onListChanged: _ctx.handleFilteredListChangedEvent
                          }, null, 8, ["selected", "onSelected", "onListChanged"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_google_map_component, {
                            dataSet: _ctx.MapItemHelper.nodeToMapItem(_ctx.filteredRootNodes),
                            selectable: true,
                            markers: true,
                            markSelected: false,
                            style: {"height":"100%"},
                            id: "map",
                            ref: "map",
                            onMarkerSelected: _ctx.handleClickedMarker
                          }, null, 8, ["dataSet", "onMarkerSelected"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "default")
                            ]),
                            _: 3
                          })
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }))
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 32))
}